import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7522e3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tags" }
const _hoisted_2 = { class: "tags-li-title" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tags-close-box" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("关闭其他")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("关闭所有")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close = _resolveComponent("close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_scroll_pane = _resolveComponent("scroll-pane")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_scroll_pane, {
      ref: "scrollPane",
      class: "tags-view-wrapper"
    }, {
      default: _withCtx(() => [
        _createVNode(_TransitionGroup, {
          name: "el-fade-in-linear",
          tag: "div",
          class: "wrapperBox",
          ref: "tagBoxRef"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsList, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.path,
                class: _normalizeClass(["tags-li", { active: _ctx.isActive(item) }]),
                to: { path: item.path, query: item.query }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(item.title), 1),
                  (!_ctx.isAffix(item) && _ctx.tagsList.length > 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "tags-li-icon",
                        onClick: _withModifiers(($event: any) => (_ctx.closeTags(item)), ["prevent","stop"])
                      }, [
                        _createVNode(_component_el_icon, { size: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_close)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class", "to"]))
            }), 128))
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_dropdown, { onCommand: _ctx.handleTags }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, { size: "small" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                disabled: _ctx.tagsList.length === 1,
                command: "other"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_el_dropdown_item, {
                disabled: _ctx.tagsList.length === 1,
                command: "all"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            icon: "caretBottom",
            size: "mini"
          })
        ]),
        _: 1
      }, 8, ["onCommand"])
    ])
  ]))
}